// NOTICE: KAPTION-INTEGRATION
// app-studio.UI.1 — App Studio (Builder-hosted, opened with a launch token).
// Open to every role at the router: the launch endpoint enforces the
// `app_studio` permission. Builder apps themselves are ordinary dashboard
// apps (full-screen route and conversation tabs), not routes of their own.
// app-studio.UI.4 — deep links: one App Studio screen per URL
// (`app-studio/apps/:appId[/:tab]`), all rendered by the same page, so moving
// between them never reloads the iframe. The params only match the App Studio
// allowlist; any other `app-studio/...` path opens App Studio's app list
// instead of falling through to the default (Conversations).
import { frontendURL } from '../../../helper/URLHelper';
import {
  ROUTE_APP,
  ROUTE_APP_TAB,
  ROUTE_INDEX,
  STUDIO_TABS,
} from './kaptionAppStudioLaunch';

const KaptionAppStudioPage = () => import('./KaptionAppStudioPage.vue');

const meta = { permissions: ['administrator', 'agent', 'custom_role'] };
const APP_ID = ':appId([a-z0-9]+)';
const TAB = `:tab(${STUDIO_TABS.join('|')})`;

export const routes = [
  {
    path: frontendURL('accounts/:accountId/app-studio'),
    name: ROUTE_INDEX,
    meta,
    component: KaptionAppStudioPage,
  },
  {
    path: frontendURL(`accounts/:accountId/app-studio/apps/${APP_ID}`),
    name: ROUTE_APP,
    meta,
    component: KaptionAppStudioPage,
  },
  {
    path: frontendURL(`accounts/:accountId/app-studio/apps/${APP_ID}/${TAB}`),
    name: ROUTE_APP_TAB,
    meta,
    component: KaptionAppStudioPage,
  },
  {
    path: frontendURL('accounts/:accountId/app-studio/:rest(.*)*'),
    name: 'kaption_app_studio_unknown',
    meta,
    redirect: to => ({
      name: ROUTE_INDEX,
      params: { accountId: to.params.accountId },
    }),
  },
];
